let VisitorCountryRedirect = function (options) {
    let root = this;

    let vars = {
        isOpen: false,
        validationCookie: false,
        validationVisitorCountry: false,
        element: null,
        elementId: "js-visitor-country-redirect",
        cookieName: "region_redirect_message",
        elementCloseButton: null,
        elementCloseButtonId: "js-visitor-country-redirect-close",
        elementMessage: null,
        elementMessageId: "js-visitor-country-redirect-message",
        elementLink: null,
        elementLinkId: "js-visitor-country-redirect-link",
    };

    this.construct = function (options) {
        vars.element = document.getElementById(vars.elementId);
        vars.elementCloseButton = document.getElementById(vars.elementCloseButtonId);
        vars.elementMessage = document.getElementById(vars.elementMessageId);
        vars.elementLink = document.getElementById(vars.elementLinkId);

        vars.elementCloseButton.addEventListener("click", root.close);

        validateToShow();
    };

    let validateToShow = function () {
        vars.isOpen = false;

        // if in cookie (user already closed it)
        if (!getCookie(vars.cookieName)) {
            vars.validationCookie = true;
        }

        // if it's a bot
        if (navigator.userAgent.toLowerCase().indexOf('bot') > -1) {
            return;
        }

        // hide banner for pagespeed.web.dev
        // on testing again and the agent changed
        // compare what changed and update the code (maybe use a wildcard for the version number)
        // https://developers.google.com/search/docs/crawling-indexing/overview-google-crawlers
        if (navigator.userAgent.toLowerCase() === "mozilla/5.0 (macintosh; intel mac os x 10_15_7) applewebkit/537.36 (khtml, like gecko) chrome/109.0.0.0 safari/537.36") {
            return;
        }
        if (navigator.userAgent.toLowerCase() === "mozilla/5.0 (linux; android 11; moto g power (2022)) applewebkit/537.36 (khtml, like gecko) chrome/109.0.0.0 mobile safari/537.36") {
            return;
        }

        // fetch the visitor country and site/page country
        let visitorCountry = document.getElementsByTagName("html")[0].getAttribute('data-ipcountry');
        if (!visitorCountry) {
            visitorCountry = document.getElementsByTagName("html")[0].getAttribute('data-country');
        }
        let elementCountry = vars.element.getAttribute('data-country');
        if (visitorCountry && visitorCountry.toUpperCase() !== elementCountry) {
            vars.validationVisitorCountry = true;
        }

        // if no cookie and countries do not match - show
        if (redirectArgs && vars.validationCookie && vars.validationVisitorCountry) {
            let locationArgs = redirectArgs.message[visitorCountry];
            if (locationArgs) { // if we support the country
                vars.elementMessage.innerHTML = locationArgs.main_message;
                vars.elementLink.innerHTML = locationArgs.leave_button_text;
                vars.elementLink.setAttribute("href", locationArgs.leave_button_href);

                vars.isOpen = true;
                vars.element.classList.remove("hidden");
                // fixing the height of the nav
                const collection = document.getElementsByClassName("nav-level-2");
                for (let i = 0; i < collection.length; i++) {
                    collection[i].style.top = "122px";
                }

                document.getElementById("mainNavMobile").style.top = "164px";
                document.getElementById("global-search-container").classList.add("geo-redirect-banner");
            }
        }
    };

    // public methods
    this.isOpen = function () {
        return vars.isOpen;
    }

    this.close = function () {
        vars.isOpen = false;
        vars.element.style.display = "none";
        setCookie(vars.cookieName, 1, 30);
         // fixing the height of the nav
         const collection = document.getElementsByClassName("nav-level-2");
         for (let i = 0; i < collection.length; i++) {
             collection[i].style.top = "";
         }

        document.getElementById("mainNavMobile").style.top = "";
        document.getElementById("global-search-container").classList.remove("geo-redirect-banner");
    }

    this.construct(options);
};

export {VisitorCountryRedirect as default};
